module.exports = __webpack_public_path__ + "img/Stephneee_Plz.029d7775.jpg";